import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useLocation } from "react-router";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
//services
import { getRolesPermissions } from "../../../services/GlobalRoles/getRolesPermissions";
import { onSubmitEditPermission } from "../../../services/Settings/AccessGroup/editPermissions";
//context
import { useAppContext } from "../../../context/AppContext";
import PermissionsTree from "./PermissionsTree";

const SeeEdit = () => {
  const { permissions: userRoles } = useAppContext();
  const { state } = useLocation();
  const rowData = state.rowData;
  const idRole = rowData.id;

  const [hasPermissionsChanged, setHasPermissionsChanged] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [truePermissions, setTruePermissions] = useState({});

  const items = [
    {
      template: () => (
        <Link to={`/settings/accessGroups`} className="p-breadcrumb-link">
          {rowData.name}
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/settings/accessGroups/seeEdit`}
          state={{ rowData }}
          className="p-breadcrumb-link"
        >
          Permissão de Acesso
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/settings/accessGroups"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: rolesPermissions, isLoading, refetch } = useQuery(
    [`rolesPermissions${idRole}`],
    () => getRolesPermissions(idRole),
    {
      enabled: !!userRoles?.includes("132"),
    }
  );

  const handleHasChanged = (e) => {
    setHasPermissionsChanged(e);
    // console.log('Has Changed:', e);
  };

  const handlePermissions = (e) => {
    setTruePermissions(e);
    // console.log('Filtered Permissions:', e);
  };

  const handleEditRoles = async (data) => {
    setLoadingEdit(true);
    if (!hasPermissionsChanged) {
      toast.warning("Você não fez nenhuma alteração nas permissões.");
      setLoadingEdit(false);
      return;
    }

    const notification = toast.loading("Aguarde, Alterando Permissões...");
    try {
      const sendData = {
        name: rowData.name,
        permissions: truePermissions.permissions
      };
      // console.log("Send data: ", sendData);
      await onSubmitEditPermission(idRole, sendData);
      toast.update(notification, {
        render: "Permissões Alteradas com Sucesso!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
        closeButton: true,
        closeOnClick: true,
      });
      refetch();
      setHasPermissionsChanged(false);
    } catch (error) {
      toast.update(notification, {
        render: "Não foi Possível Alterar as Permissões!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
        clloseButton: true,
      });
    }
    setLoadingEdit(false);
  };

  const MyButton = ({ loading }) => (
    <Button
      type="submit"
      rounded
      label="Salvar"
      icon="fa fa-plus"
      className="p-inputtext-sm m-auto"
      loading={loading}
      onClick={() => handleEditRoles()}
    />
  );

  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel title="Permissões de Acesso" button={!isLoading ? <MyButton loading={loadingEdit} /> : null}>
        {!isLoading && (
          <PermissionsTree
            roles={rolesPermissions}
            onHasChanged={(e) => handleHasChanged(e)}
            onFilteredPermissions={(e) => handlePermissions(e)}
          />
        )}

        {isLoading && (
          <Skeleton width="100%" height="80vh"></Skeleton>
        )}
      </Panel>
    </>
  );
};

export default SeeEdit;
